import { tweenConfigs } from "../../../helpers/tweensConfigs";
import { WebSocketManager } from "../../../helpers/webSocketManager";
import router from "../../../../../routes";

export class MiniTableMenu {
  constructor(scene) {
    this.scene = scene;
    this.menuGroup = this.scene.add.group();
    this.menuIsShowing = false;
    this.allowMenuToggle = true;
    this.aMiniTable = null;
    this.yDistanceBetween = 0;
    this.atlasTexture = this.scene.atlasTexture;
    this.exitTableBtn = this.scene.add
      .image(0, 0, this.atlasTexture, "exit-table-mini-table")
      .setOrigin(0)
      .setDepth(101)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", this.exitTableOnClick, this);
    this.lobbyBtn = this.scene.add
      .image(0, 0, this.atlasTexture, "lobby-mini-table")
      .setOrigin(0)
      .setDepth(101)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", this.lobbyOnClick, this);
    this.sitOutBtn = this.scene.add
      .image(0, 0, this.atlasTexture, "sit-out-mini-table")
      .setOrigin(0)
      .setDepth(101)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", this.sitOutOnClick, this);
    this.cTimeBtn = this.scene.add
      .image(0, 0, this.atlasTexture, "c-time-mini-table")
      .setOrigin(0)
      .setDepth(101)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", this.counterTimeOnClick, this);

    this.menuGroup.addMultiple([
      this.exitTableBtn,
      this.sitOutBtn,
      // this.sitOutBtn,
      this.cTimeBtn,
      this.lobbyBtn,
    ]);
    this.visibleChildren = [];
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    this.overlay.setAlpha(0.01).setVisible(false);
    this.overlay.setDepth(100);
  }
  lobbyOnClick() {
    if (this.scene.getVisitedTableGame().getClubId()) {
      router.push(`/lobby/${this.scene.getVisitedTableGame().getClubId()}`);
    } else router.push("/home");
  }
  sitOutOnClick() {
    const visitedTable = this.scene.getVisitedTable();
    this.overlayOnClick();
    this.scene.Swal.fire({
      title: "Are You Sure You Want to Sit Out?",
      // html: hTML,
      showCancelButton: true,
      confirmButtonText: "OK",
      customClass: {
        title: "sweet-alert-title",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.sitOutBtn.disableInteractive();
        WebSocketManager.emitEvent(
          { tableId: visitedTable.tableInfo.id },
          "poker.client-push.sit-out"
        )
          .then((_) => {
            this.sitOutBtn.setInteractive();
          })
          .catch((_) => {
            this.sitOutBtn.setInteractive();
          });
      }
    });
  }
  exitTableOnClick() {
    this.overlayOnClick();
    let hTML = "";
    const visitedTable = this.scene.getVisitedTable();
    const title = `Are You Sure You Want to Leave the ${
      visitedTable.isTournamentTable() ? "Tournament" : "Table"
    } ?`;
    if (visitedTable.gameState.playerInfo) {
      if (!visitedTable.isTournamentTable()) {
        hTML = `${visitedTable.tableInfo.tableType}<br>
        ${visitedTable.tableInfo.name} - ${
          visitedTable.tableInfo.smallBlinds
        } / ${visitedTable.tableInfo.bigBlinds}<br>
        Cash-out Amount ${visitedTable.gameState.playerInfo.balance.toLocaleString()}`;
      }
      this.scene.Swal.fire({
        title: title,
        html: hTML,
        showCancelButton: true,
        confirmButtonText: "OK",
        customClass: {
          title: "sweet-alert-title",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.exitTableBtn.disableInteractive();
          WebSocketManager.emitEvent(
            { tableId: visitedTable.tableInfo.id },
            "poker.client-push.observe-not"
          )
            .then((_) => {
              this.exitTableBtn.setInteractive();
              this.scene.alertify.dismissAll();
              this.scene.destroyTableGame(visitedTable.tableInfo.id);
            })
            .catch((_) => {
              this.exitTableBtn.setInteractive();
            });
        }
      });
    } else {
      this.exitTableBtn.disableInteractive();
      WebSocketManager.emitEvent(
        { tableId: visitedTable.tableInfo.id },
        "poker.client-push.observe-not"
      )
        .then((_) => {
          this.exitTableBtn.setInteractive();
          this.scene.alertify.dismissAll();
          this.scene.destroyTableGame(visitedTable.tableInfo.id);
        })
        .catch((_) => {
          this.exitTableBtn.setInteractive();
        });
    }
  }
  counterTimeOnClick() {
    this.cTimeBtn.disableInteractive();
    WebSocketManager.emitEvent(
      { tableId: this.scene.getVisitedTable().tableInfo.id },
      "poker.client-push.counter-time"
    )
      .then((res) => {
        this.cTimeBtn.setInteractive();
        if (this.scene.alertify)
          this.scene.alertify.typeSuccess("Counter time was started.");
        this.cTimeBtn.disable();
        this.overlayOnClick();
      })
      .catch((_) => {
        this.cTimeBtn.setInteractive();
      });
  }
  show() {
    if (this.allowMenuToggle && this.scene.isSceneObjectsInteractive) {
      this.allowMenuToggle = false;
      /* In every show menu, positions should be updated since the visited table might be changed, and we have only one menu.*/
      this.updatePositions();
      this.updateDisplay();
      this.showOverlay();
      this.exitTableBtn.setInteractive({ cursor: "pointer" });
      this.lobbyBtn.setInteractive({ cursor: "pointer" });
      this.sitOutBtn.setInteractive({ cursor: "pointer" });
      this.cTimeBtn.setInteractive({ cursor: "pointer" });
      this.menuIsShowing = true;
      // this.scene.tweens.add({
      //   targets: this.menuGroup.getChildren(),
      //   ease: tweenConfigs.miniTableMenu.show.ease,
      //   duration: tweenConfigs.miniTableMenu.show.duration,
      //   alpha: 1,
      //   onComplete: () => {
      //     this.allowMenuToggle = true;
      //   },
      // });
      this.visibleChildren.forEach(function (child, i) {
        this.scene.tweens.add({
          targets: child,
          ease: tweenConfigs.miniTableMenu.show.ease,
          duration: tweenConfigs.miniTableMenu.show.duration,
          delay: i * 80,
          // yoyo: true,
          // alpha: {
          //   // delay: 270 + i * 70,
          //   delay: tweenConfigs.sideMenu.show.duration - 30,
          //   value: 1,
          //   duration: 30,
          //   ease: "Power2",
          //   yoyo: false,
          // },
          alpha: 1,
          onComplete: () => {
            if (i === this.visibleChildren.length - 1) {
              this.allowMenuToggle = true;
            }
          },
        });
      }, this);
    }
  }
  showOverlay() {
    if (!this.overlay.visible) this.overlay.setVisible(true);
  }
  async overlayOnClick() {
    // this.scene.changeObjectsInteractivity(true);
    return new Promise((resolve) => {
      if (this.allowMenuToggle && this.menuIsShowing) {
        this.allowMenuToggle = false;
        this.menuIsShowing = false;
        this.hideOverlay();
        this.scene.tweens.add({
          targets: this.menuGroup.getChildren(),
          duration: tweenConfigs.miniTableMenu.hide.duration,
          ease: tweenConfigs.miniTableMenu.hide.ease,
          alpha: 0,
          // yoyo: true,
          onComplete: () => {
            this.allowMenuToggle = true;
            Phaser.Actions.SetVisible(this.menuGroup.getChildren(), false);
            resolve();
          },
        });
      }
    });
  }
  hide() {
    this.overlayOnClick();
  }
  hideOverlay() {
    if (this.overlay.visible) this.overlay.setVisible(false);
  }
  /*
   * Are buttons disabled or not?
   */
  updateDisplay() {
    this.enableAllButtons();
    const visitedTable = this.scene.getVisitedTable();
    const playerInfo = visitedTable.gameState.playerInfo;
    if (playerInfo) {
      /* The selfPlayer has sat. */
      if (playerInfo.state === "SitOut") {
        if (this.sitOutBtn.visible) this.sitOutBtn.setVisible(false);
        if (this.cTimeBtn.visible) this.cTimeBtn.setVisible(false);
      }
      if (
        visitedTable.gameState.otherPlayers.length === 0 ||
        playerInfo.counterTimeActivated ||
        playerInfo.counterTimePassed ||
        playerInfo.totalWinLoss <= 0
      ) {
        if (this.cTimeBtn.visible) this.cTimeBtn.setVisible(false);
      }
    } else {
      /*The selfPlayer has not sat.*/
      if (this.sitOutBtn.visible) this.sitOutBtn.setVisible(false);
      if (this.cTimeBtn.visible) this.cTimeBtn.setVisible(false);
    }
    if (visitedTable.tableInfo.counterTime === 0 && this.cTimeBtn.visible) {
      this.cTimeBtn.setVisible(false);
    }
    this.visibleChildren = this.menuGroup
      .getChildren()
      .filter((child) => child.visible);
    this.visibleChildren.forEach((child, i) => {
      child.setY(
        (i === 0
          ? this.aMiniTable.miniTable.y +
            this.aMiniTable.miniTable.displayHeight * 1.25
          : this.visibleChildren[i - 1].y +
            this.visibleChildren[i - 1].displayHeight) + this.yDistanceBetween
      );
    });
  }
  enableAllButtons() {
    Phaser.Actions.SetVisible(this.menuGroup.getChildren(), true);
  }
  positionControls(width, height, miniTable) {
    this.aMiniTable = miniTable;
    // this.yDistanceBetween = miniTable.miniTable.displayHeight * 0.03;
    this.menuGroup.children.iterate((child, i) => {
      child.setScale(miniTable.miniTable.scale * 1.2);
      // child.setX(miniTable.miniTable.x);
      // child.setY(miniTable.miniTable.y + miniTable.miniTable.displayHeight + i * (child.displayHeight) + ( (i + 2) * this.yDistanceBetween));
    }, this);

    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );

    Phaser.Actions.SetAlpha(this.menuGroup.getChildren(), 0);

    this.overlay.setInteractive(
      new Phaser.Geom.Rectangle(
        0,
        0,
        this.overlay.displayWidth,
        this.overlay.displayHeight
      ),
      Phaser.Geom.Rectangle.Contains
    );
    this.overlay.on("pointerdown", this.overlayOnClick, this);
  }
  reposition(width, height, miniTable) {
    this.aMiniTable = miniTable;

    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );
  }
  updatePositions() {
    this.overlay.setX(
      this.scene.getVisitedTableGameIndex() * this.overlay.width
    );
    // const x =
    //   (this.scene.gameWidth +
    //     this.aMiniTable.distanceBetween +
    //     this.aMiniTable.miniTable.displayWidth) *
    //     this.scene.getVisitedTableGameIndex() +
    //   this.aMiniTable.startDistance +
    //   (this.aMiniTable.miniTable.displayWidth -
    //     this.menuGroup.getChildren()[0].displayWidth) /
    //     2;
    const x =
      (this.scene.gameWidth +
        this.aMiniTable.distanceBetween +
        this.aMiniTable.miniTable.displayWidth) *
        this.scene.getVisitedTableGameIndex() +
      this.aMiniTable.startDistance;
    Phaser.Actions.SetX(this.menuGroup.getChildren(), x);
  }
}
